import Reflux from "reflux";

import SiteService from "../service/SiteService.mjs";
import AppConstants from "../constants/AppConstants";
import SiteDesignStore from "../stores/SiteDesignStore";
import SiteActions from "./SiteActions";
import DocumentStore from "../document/DocumentStore";
import { COMMANDS } from "../document/commands";
import DesignChooserActions from "./DesignChooserActions";
import { getUserId } from "../hooks/query/useAccount";
import { getSiteId } from "../hooks/query/useSite";
import { toLocalTimeString } from "../utils/DateUtils";

var AdminActions = Reflux.createActions({
  restoreSite: { asyncResult: true },
  restorePage: { asyncResult: true, children: ["old", "current"] },
  restorePageCompleted: { asyncResult: true },
  restoreCanvas: { asyncResult: true },
  restoreSiteBlock: { asyncResult: true },
  getSiteBackups: { asyncResult: true, children: ["complete", "fail"] },
});

AdminActions.getSiteBackups.listen(async function (siteKey) {
  SiteService.getSiteBackups(
    { site_id: getSiteId(), user_id: getUserId() },
    { siteKey: siteKey }
  )
    .then((response) => {
      return response.backups.map(_massageBackupForViews).reverse();
    })
    .then(this.complete)
    .catch((error) => {
      alert("Failed to fetch backups from amazon: \n" + error);
    });
});

AdminActions.restoreSite.listen(function (payload) {
  const id = getSiteId();
  const urlInfo = {
    site_id: id,
    user_id: getUserId(),
  };

  _closeAdminDialog();

  SiteService.restoreSite(urlInfo, payload)
    .then(_reloadApp)
    .catch((error) => {
      alert(
        "Error restoring site.  Please stop and grab a dev to fix this. (cookies are welcome) \n" +
          error
      );
    });
});

AdminActions.restorePage.listen(function (selection, designData) {
  const currentPage = SiteDesignStore.getCurrentPage();

  if (currentPage.id === selection.id) {
    this.current(designData.item);
  } else {
    const currentPageIds = SiteDesignStore.getPageIds();
    if (currentPageIds.includes(selection.id)) {
      alert(
        "Error restoring a page that is not loaded.  Exit the restore dialog, select the correct page in the app, and launch the restore tool again."
      );
    } else {
      this.old(designData.item);
    }
  }
});

AdminActions.restoreSiteBlock.listen(function (selection, designData) {
  const payload = {
    block: designData.item,
  };

  const existingSiteBlock = SiteDesignStore.getDesign().hasBlock(selection.id);
  if (existingSiteBlock) {
    DocumentStore.dispatch({ type: COMMANDS.REPLACE_SITE_BLOCK, payload });
  } else {
    DocumentStore.dispatch({ type: COMMANDS.ADD_SITE_BLOCK, payload });
  }
});

AdminActions.restoreCanvas.listen(function (selection, designData) {
  const currentPage = SiteDesignStore.getCurrentPage();

  if (currentPage.id !== selection.pageId) {
    alert(
      "Error restoring to a page that is not loaded.  Exit the restore dialog, select the correct page in the app, and launch the dialog again."
    );
  } else {
    if (currentPage.hasBlock(selection.id)) {
      DocumentStore.dispatch({ type: COMMANDS.REPLACE_BLOCK, payload: designData.item });
    } else {
      DocumentStore.dispatch({ type: COMMANDS.ADD_BLOCK, payload: { block: designData.item } });
    }
  }
});

SiteActions.replaceBlockCompleted.listen(_closeAdminDialog);
SiteActions.replaceSiteBlockCompleted.listen(_closeAdminDialog);
SiteActions.addBlockCompleted.listen(_closeAdminDialog);
SiteActions.addSiteBlockCompleted.listen(_closeAdminDialog);
AdminActions.restorePageCompleted.listen(_closeAdminDialog);

function _closeAdminDialog() {
  DesignChooserActions.closeDialog();
}

function _reloadApp() {
  window.location.reload();
}

function _massageBackupForViews(backup) {
  backup.name = toLocalTimeString(backup.create_date);
  backup.type = AppConstants.DESIGN_TYPE_SITE;
  backup.key = backup.id = `${backup.site_design_key}/${backup.create_date}`;
  return backup;
}

export default AdminActions;
